import React from 'react'

import { TtIcon } from '@23/react'

import './FocusPreviewTrayMixOutput.scss'

const FocusPreviewTrayMixOutput = () => {
  return (
    <div className="focus-preview-tray-mix-output">
      <div className="focus-preview-tray-mix-output-frame">
        <TtIcon library="one/webinars" name="tray-closed" />
      </div>
    </div>
  )
}

export { FocusPreviewTrayMixOutput }
